import React from "react";
import { FiArrowLeft, FiCalendar, FiLoader, FiRefreshCcw } from "react-icons/fi";
import { YEAR } from "../../EDADashboard/utils";

const DEFAULT_YEAR = 2026;

const Header = ({
  segmentTitle,
  selectedProcess,
  dashboard,
  navigate,
  selectedYear,
  setSelectedYear,
  loading,
  periodOptions,
  selectedPeriod,
  setSelectedPeriod,
}) => {
  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-gradient-to-b from-slate-50 to-white p-4 shadow-sm">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">
            {segmentTitle} - Fixed Cost Optimization
          </h1>
          <p className="mt-1 text-sm text-slate-500">
            Process: {selectedProcess} | Status:{" "}
            {dashboard?.edaStatus || "Available"}
          </p>
        </div>

        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 self-start rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 shadow-sm transition hover:border-slate-300 hover:text-slate-800"
        >
          <FiArrowLeft className="h-4 w-4" />
          Back
        </button>
      </div>

      <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
        <div className="flex flex-col gap-3 md:flex-row md:items-center">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-slate-400">Year</span>
            <select
              value={selectedYear}
              onChange={(event) => setSelectedYear(Number(event.target.value))}
              disabled={loading}
              className="min-w-[120px] rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 outline-none transition focus:border-blue-300 disabled:cursor-not-allowed disabled:bg-slate-50"
            >
              {YEAR.map((year) => (
                <option key={year.value} value={year.value}>
                  {year.label}
                </option>
              ))}
            </select>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-slate-400">Period</span>
            <select
              value={selectedPeriod?.value || ""}
              onChange={(e) =>
                setSelectedPeriod(
                  periodOptions.find((option) => option.value === e.target.value)
                )
              }
              disabled={loading || !periodOptions.length}
              className="min-w-[180px] rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 outline-none transition focus:border-blue-300 disabled:cursor-not-allowed disabled:bg-slate-50"
            >
              {periodOptions.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            onClick={() => {
              if (periodOptions.length) {
                setSelectedPeriod(periodOptions[0]);
              }
              setSelectedYear(DEFAULT_YEAR);
            }}
            disabled={loading}
            className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-500 shadow-sm transition hover:border-slate-300 hover:text-slate-700 disabled:cursor-not-allowed disabled:bg-slate-50"
          >
            <FiRefreshCcw className="h-3.5 w-3.5" />
            Reset
          </button>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          {loading && (
            <div className="inline-flex items-center gap-2 rounded-full border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-medium text-blue-700">
              <FiLoader className="h-4 w-4 animate-spin" />
              Loading summary...
            </div>
          )}

          {selectedPeriod && (
            <div className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-medium text-emerald-700">
              <FiCalendar className="h-4 w-4" />
              Current period: {selectedPeriod.label} of {selectedYear}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
